<template>
  <div class="all-wrap">
    <header>
      <a
        href="#content"
        id="gotocenter"
        title="移至主要內容"
        class="toContent"
        >跳到主要內容</a
      >
      <div class="container">
        <router-link
          to="/"
          style="font-size: 0">
          防災資訊服務網
          <div
            class="logo"
            style="cursor: pointer">
            <h1>
              <a>防災資訊服務網</a>
            </h1>
          </div>
        </router-link>
        <nav>
          <span class="menu-btn-inner">
            <img
              :src="`${baseUrl}images/menu-btn.svg`"
              alt=""
              v-once />
          </span>
          <div class="top-nav">
            <a
              href="#"
              title="上方選單導盲磚"
              accesskey="U"
              >:::</a
            >
            <a
              href="https://docs.google.com/forms/d/151S5VkhmGmvwnJVVp0k1PFXZ9GLU9oJOJ4emf2OYPL4/viewform?chromeless=1&edit_requested=true"
              target="_blank"
              title="滿意度調查(另開新視窗)">
              滿意度調查
            </a>
            <a
              href="https://fhy.wra.gov.tw/FloodNotify/SMSSignUp"
              title="接收淹水警戒簡訊(另開新視窗)"
              target="_blank"
              >接收淹水警戒簡訊</a
            >
            <a
              href="https://fhy.wra.gov.tw/FloodNotify/VoiceSignup"
              target="_blank"
              title="接收淹水警戒語音廣播(另開新視窗)"
              >接收淹水警戒語音廣播</a
            >
            <!-- <a href="">ENGLISH</a> -->
            <!-- <router-link to="/alert/warn_en">ENGLISH</router-link> -->
            <a
              href="https://fhy.wra.gov.tw/fhykids/"
              target="_blank"
              title="兒童版(另開新視窗)"
              >兒童版</a
            >
            <ul class="main-nav top-nav-ul">
              <li class="top-nav-li">
                <a href="#">LANGUAGE</a>
                <ul class="sub-nav">
                  <li><router-link to="/alert/warn/en">English</router-link></li>
                  <li><router-link to="/alert/warn/ja">日本語</router-link></li>
                  <li><router-link to="/alert/warn/fr">Français</router-link></li>
                  <li><router-link to="/alert/warn/ru">Русский</router-link></li>
                  <li><router-link to="/alert/warn/es">Español</router-link></li>
                  <li><router-link to="/alert/warn/ar">اَلْعَرَبِيَّةُ</router-link></li>
                  <li><router-link to="/alert/warn/th">ภาษาไทย</router-link></li>
                  <li><router-link to="/alert/warn/vi">Bahasa Indonesia</router-link></li>
                  <li><router-link to="/alert/warn/id">Tiếng Việt</router-link></li>
                </ul>
              </li>
            </ul>
          </div>
          <ul class="main-nav">
            <li id="mn-1">
              <router-link to="/sitemap">網站導覽</router-link>
            </li>
            <li id="mn-2">
              <a href="#">防災快訊</a>
              <ul class="sub-nav">
                <li><router-link to="/alert/news">最新消息</router-link></li>
                <li><router-link to="/alert/message">警戒訊息</router-link></li>
                <li><router-link to="/alert/weather">警報訊息</router-link></li>
                <li><router-link to="/alert/otherWarn">示警訊息</router-link></li>
              </ul>
            </li>
            <li id="mn-3">
              <a href="#">警戒資訊</a>
              <ul class="sub-nav">
                <li><router-link to="/alert/warn">綜合警戒</router-link></li>
                <li><router-link to="/alert/rain">淹水警戒</router-link></li>
                <li><router-link to="/alert/water">水位警戒</router-link></li>
                <li><router-link to="/alert/reservoir">水庫警戒</router-link></li>
                <li><router-link to="/service/alertQuery">警戒查詢</router-link></li>
                <li>
                  <a
                    href="https://fhy.wra.gov.tw/mobile/v1/api/image/Drought"
                    target="_blank"
                    title="供水情勢(另開新視窗)"
                    aria-label="供水情勢"
                    >供水情勢(另開新視窗)</a
                  >
                </li>
                <li>
                  <a
                    href="https://fhy.wra.gov.tw/kyszinfo/FloodData.aspx"
                    target="_blank"
                    title="員山子分洪(另開新視窗)"
                    aria-label="員山子分洪"
                    >員山子分洪(另開新視窗)</a
                  >
                </li>
              </ul>
            </li>
            <li id="mn-4">
              <a href="#">監控資訊</a>
              <ul class="sub-nav">
                <li><router-link to="/monitor/weather">即時氣象</router-link></li>
                <li><router-link to="/monitor/rain">即時雨量</router-link></li>
                <li><router-link to="/monitor/water">即時水位</router-link></li>
                <li><router-link to="/monitor/reservoir">水庫水情</router-link></li>
                <li><router-link to="/monitor/cctv">即時影像</router-link></li>
                <li><router-link to="/monitor/floodMap">即時感測器</router-link></li>
                <li><router-link to="/monitor/disasterMap">即時災情</router-link></li>
                <!-- <li><router-link to="/monitor/waterRuler">智慧水尺</router-link></li> -->
              </ul>
            </li>
            <li id="mn-5">
              <a href="#">防汛整備</a>
              <ul class="sub-nav">
                <li><router-link to="/flood/device">防汛器材整備</router-link></li>
                <li><router-link to="/flood/platform">防汛作業平台</router-link></li>
                <li><router-link to="/disaster/volunteer">防汛志工專區</router-link></li>
                <li><router-link to="/disaster/community">防災社區介紹</router-link></li>
              </ul>
            </li>
            <li id="mn-6">
              <a href="#">便民服務</a>
              <ul class="sub-nav">
                <li><router-link to="/service/knowledge">防災知識</router-link></li>
                <li><router-link to="/service/tools">防災工具</router-link></li>
                <li><router-link to="/service/video">防災影音</router-link></li>
                <li><router-link to="/disaster/floodRescue">防災救助</router-link></li>
                <li>
                  <a
                    href="https://web.wra.gov.tw/ferc/"
                    target="_blank"
                    title="水利防災經驗學習中心(另開新視窗)"
                    >防災經驗</a
                  >
                </li>
                <li><router-link to="/disaster/downloads">檔案下載</router-link></li>
                <li><router-link to="/service/partner">防汛夥伴</router-link></li>
              </ul>
            </li>
          </ul>
        </nav>
        <span class="menu-btn">
          <img
            :src="`${baseUrl}images/menu-btn.svg`"
            alt=""
            v-once />
        </span>
      </div>
      <div
        class="special-nav"
        style="height: 44.73px">
        <div class="container">
          <div class="width-100 flex">
            <div class="width-50 flex">
              <router-link
                to="/alert/rain"
                class="red"
                v-show="realTimeAlerm.Flood == 1">
                <img
                  :src="`${baseUrl}images/sicon-01-red.svg`"
                  alt=""
                  v-once />
                <span>淹水</span>
              </router-link>
              <router-link
                to="/alert/water"
                class="red"
                v-show="realTimeAlerm.Water == 1">
                <img
                  :src="`${baseUrl}images/sicon-02-red.svg`"
                  alt=""
                  v-once />
                <span>水位</span>
              </router-link>
              <a
                href="https://fhy.wra.gov.tw/mobile/v1/api/image/Drought"
                title="供水情勢(另開新視窗)"
                target="_blank"
                class="red"
                v-show="realTimeAlerm.Drought == 1">
                <img
                  :src="`${baseUrl}images/sicon-03-red.svg`"
                  alt=""
                  v-once />
                <span>水情</span>
              </a>
              <router-link
                to="/alert/reservoir"
                class="red"
                v-show="realTimeAlerm.Reservoir == 1">
                <img
                  :src="`${baseUrl}images/sicon-04-red.svg`"
                  alt=""
                  v-once />
                <span>水庫</span>
              </router-link>
              <a
                target="_blank"
                class="red"
                href="https://fhy.wra.gov.tw/kyszinfo/FloodData.aspx"
                title="員山子分洪道(另開新視窗)"
                v-show="realTimeAlerm.Yuanshan == 1">
                <img
                  :src="`${baseUrl}sicon-05-red.svg`"
                  alt=""
                  v-once />
                <span>員山子</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <loading :active.sync="isLoading"></loading>
    <router-view id="content" />
    <footer>
      <div class="container">
        <div
          class="footer-info"
          style="display: flex">
          <div>
            <p>今日瀏覽人數： {{ counter.sum }} 自民國99年起計累積瀏覽人數： {{ counter.total }}</p>
            <p>經濟部水利署©2015 版權所有,轉載必究　平時：(02)3707-3128</p>
            <p>颱風豪雨(02)3707-3110 或 (02)3707-3119　系統維護：三川雲科技股份有限公司(02)7746-1628</p>
          </div>
          <div>
            <img
              :src="`${baseUrl}images/A等級標章.jpg`"
              alt=""
              v-once />
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

const deepCopyObject = (obj) => JSON.parse(JSON.stringify(obj));

export default {
  components: { Loading },
  data() {
    return {
      isLoading: false,
      weatherImage: [],
      accumulationRainImage: [],
      typhoonImage: [],
      waterLevelRealTimeData: [],
      rainfallRealTimeData: [],
      realTimeAlerm: {
        Drought: 0,
        Flood: 0,
        Reservoir: 0,
        Water: 0,
        Yuanshan: 0,
      },
      cities: [
        { code: "", name: "全縣市" },
        { code: "63", name: "臺北市" },
        { code: "65", name: "新北市" },
        { code: "10017", name: "基隆市" },
        { code: "68", name: "桃園市" },
        { code: "10004", name: "新竹縣" },
        { code: "10018", name: "新竹市" },
        { code: "10005", name: "苗栗縣" },
        { code: "66", name: "臺中市" },
        { code: "10007", name: "彰化縣" },
        { code: "10008", name: "南投縣" },
        { code: "10009", name: "雲林縣" },
        { code: "10010", name: "嘉義縣" },
        { code: "10020", name: "嘉義市" },
        { code: "67", name: "臺南市" },
        { code: "64", name: "高雄市" },
        { code: "10013", name: "屏東縣" },
        { code: "10002", name: "宜蘭縣" },
        { code: "10015", name: "花蓮縣" },
        { code: "10014", name: "臺東縣" },
        { code: "10016", name: "澎湖縣" },
        { code: "09020", name: "金門縣" },
        { code: "09007", name: "連江縣" },
      ],
      towns: [],
      news: [],
      eventOn: false,
      cwb: [],
      cap: [],
      geoCityCode: "",
      weatherImageWithInfo: [],
      counter: { sum: 0, total: 0 },
      isCheckingImg: false,
      baseUrl: process.env.BASE_URL,
    };
  },
  mounted() {
    $(".menu-btn").click(function () {
      $("header nav").toggleClass("open");
    });
    $(".menu-btn-inner").click(function () {
      $("header nav").toggleClass("open");
    });
    $(".main-nav a").click(function () {
      let opened = false;
      if ($(this).next(".sub-nav").hasClass("open")) opened = true;
      $(".sub-nav").removeClass("open");
      if (!opened) $(this).next(".sub-nav").toggleClass("open");
    });
    $(".qa-txt").hide();
    $(".qa-block h2").click(function () {
      $(this).next(".qa-txt").slideToggle("slow");
    });
    $(".sub-nav a").click(function () {
      $("header nav").removeClass("open");
    });
    $("#menuSitemap").click(function () {
      $("header nav").removeClass("open");
    });
    if (navigator.geolocation) navigator.geolocation.getCurrentPosition(this.showPosition);

    this.refreshCounter();

    //https://fhy.wra.gov.tw/Api/v2/Basic/BaseCity?$format=json
    //鄉鎮資料
    this.$http.get("https://fhy.wra.gov.tw/Api/v2/Basic/BaseTown?$format=json").then((ret) => (this.towns = ret.data));
    this.refreshData();
    setInterval(() => this.refreshData(), 600000);
  },
  watch: {
    $route(to, from) {
      this.refreshCounter();
      if (to.name == "/") {
        let homeindex = this.$children.find((a) => a.$el.id == "homeindex");
        setTimeout(() => {
          if (homeindex != undefined) {
            homeindex.load();
            homeindex.changeEventMsg();
          }
        }, 500);
      }
    },
  },
  methods: {
    showPosition(position) {
      this.$http
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${process.env.VUE_APP_GOOGLEAPIS_KEY}&language=zh-TW`
        )
        .then((ret) => {
          let _cityName = ret.data.plus_code.compound_code.substr(ret.data.plus_code.compound_code.indexOf("台灣") + 2, 3);
          let geo = this.cities.find((a) => a.name == _cityName || a.name.replace("臺", "台") == _cityName);
          if (geo) this.geoCityCode = geo.code;
        });
    },
    ckImgExist(url) {
      return new Promise((resolve, reject) => {
        this.isCheckingImg = true;
        var imgObj = new Image();
        imgObj.src = url;
        imgObj.onload = (res) => {
          this.isCheckingImg = false;
          resolve(res);
        };
        imgObj.onerror = (res) => {
          this.isCheckingImg = false;
          reject(res);
        };
      });
    },
    refreshData() {
      //即時警戒燈號
      Promise.all([
        this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/LampWarning/Drought?$format=JSON`),
        this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/LampWarning/Flood?$format=JSON`),
        this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/LampWarning/Reservoir?$format=JSON`),
        this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/LampWarning/WaterLevel?$format=JSON`),
        this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/LampWarning/Yuanshan?$format=JSON`),
      ]).then(([drought, flood, reservoir, waterLevel, yuanshan]) => {
        this.realTimeAlerm.Drought = drought.data;
        this.realTimeAlerm.Flood = flood.data;
        this.realTimeAlerm.Reservoir = reservoir.data;
        this.realTimeAlerm.Water = waterLevel.data;
        this.realTimeAlerm.Yuanshan = yuanshan.data;
      });

      //即時氣象圖檔
      this.$http.get("https://fhy.wra.gov.tw/mobile/v1/api/image?$format=json").then((ret) => {
        this.weatherImageWithInfo = [];
        //氣象圖資
        this.weatherImage = [];

        let a = ret.data.Groups.find((r) => r.GroupTitle == "氣象觀測圖");
        let b = a.Items.find((r) => r.ItemTitle == "衛星雲圖");
        let c = b.Images.find((r) => r.ID == "Cloud_Taiwan");
        let cLink = c.Link[c.Link.length - 1];

        this.ckImgExist(cLink).then(() => {
          this.weatherImage.push(cLink);
          this.weatherImageWithInfo.push({ ItemTitle: "衛星雲圖", ImgUrl: cLink });
        });

        let d = a.Items.find((r) => r.ItemTitle == "雷達回波");
        let dLink = d.Images[0].Link[d.Images[0].Link.length - 1];

        this.ckImgExist(dLink).then(() => {
          this.weatherImage.push(dLink);
          this.weatherImageWithInfo.push({ ItemTitle: "雷達回波", ImgUrl: dLink });
        });

        let e = ret.data.Groups.find((r) => r.GroupTitle == "雨量累積/預測圖");
        let f = e.Items.find((r) => r.ItemTitle == "累積雨量圖");
        let g = f.Images.find((r) => r.Name == "一日累積");

        this.ckImgExist(g.Link[0]).then(() => {
          this.weatherImage.push(g.Link[0]);
          this.weatherImageWithInfo.push({ ItemTitle: "一日累積雨量", ImgUrl: g.Link[0] });
        });
        //定量降雨預報
        this.accumulationRainImage = [];
        for (let i = 1; i <= 8; i++) {
          let forecastLink = e.Items.find((r) => r.ItemTitle == `6小時定量降雨預報圖(${i})`).Images[0].Link[0];
          this.ckImgExist(forecastLink).then(() => this.accumulationRainImage.push(forecastLink));
        }
        //颱風預報
        this.typhoonImage = [];
        let TYInvade = a.Items.find((r) => r.ItemTitle == "颱風七級風暴風圈侵襲機率圖");
        if (TYInvade) {
          let TYPath = a.Items.find((r) => r.ItemTitle == "颱風路徑潛勢預測圖");
          let TYWarn = a.Items.find((r) => r.ItemTitle == "颱風警報單");

          this.ckImgExist(TYInvade.Images[0].Link[0]).then(() => this.typhoonImage.push(deepCopyObject(TYInvade)));

          this.typhoonImage.push(deepCopyObject(a.Items.find((r) => r.ItemTitle == "颱風各國預報路徑圖")));

          this.ckImgExist(TYPath.Images[0].Link[0]).then(() => this.typhoonImage.push(deepCopyObject(TYPath)));
          this.ckImgExist(TYWarn.Images[0].Link[0]).then(() => this.typhoonImage.push(deepCopyObject(TYWarn)));
        }
      });

      //即時水位資料 依水位desc
      this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/WaterLevel/RealTimeInfo/City/全部?$format=JSON&$orderby=WaterLevel desc").then((ret) => {
        let homeindex = this.$children.find((a) => a.$el.id == "homeindex");

        this.waterLevelRealTimeData = [];
        this.waterLevelRealTimeData = ret.data;
        this.waterLevelRealTimeData.forEach((a) => {
          if (a.WarningLevel == 1) a.color = "red";
          else if (a.WarningLevel == 2) a.color = "orange";
          else if (a.WarningLevel == 3) a.color = "yellow";
          else a.color = "green";
        });
        //若子頁面為首頁，render水位資料
        if (homeindex != undefined) homeindex.fShowWaterLevel();
      });

      //即時雨量資料 依一小時雨量desc
      this.$http
        .get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Rainfall/RealTimeInfo/City/%E5%85%A8%E9%83%A8?$orderby=H1%20desc&$format=JSON")
        .then((ret) => {
          let homeindex = this.$children.find((a) => a.$el.id == "homeindex");
          this.rainfallRealTimeData = [];
          this.rainfallRealTimeData = ret.data;

          //若子頁面為首頁，render雨量資料
          if (homeindex != undefined) homeindex.fShowRainfall();
        });

      //最新消息
      this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/News?$format=JSON&$orderby=Time%20desc").then((ret) => {
        this.news = [];
        this.news = ret.data;
      });

      let dt = new Date(),
        year = dt.getFullYear();
      //判斷事件成立
      this.$http.get(`https://fhy.wra.gov.tw/Api/v2/Event/Year/${year}?$format=json&$top=1`).then((ret) => {
        let responseData = ret.data;
        let eventType = responseData.Data[0].EventNo.split("")[0];
        let isActive = responseData.Data[0].IsActive;
        let isEvent = ["B", "R", "T"].includes(eventType) && isActive == 1 ? true : false;
        this.eventOn = isEvent;
      });

      //警報訊息,示警訊息
      Promise.all([
        this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Alert/CWB?$format=JSON"),
        this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Alert/Cap?$format=JSON"),
      ]).then(([ret1, ret2]) => {
        let homeindex = this.$children.find((a) => a.$el.id == "homeindex");

        this.cwb = ret1.data;
        this.cap = ret2.data;
        if (homeindex != undefined) homeindex.changeEventMsg();
      });
    },
    refreshCounter() {
      //瀏覽計次
      this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/Counter?%24format=JSON").then((ret) => {
        this.counter.sum = ret.data.Sum;
        this.counter.total = ret.data.Total;
      });
    },
  },
};
</script>
<style scoped>
.toContent {
  margin: 0 0 0 -100px;
}
.toContent:focus {
  margin: 0 0 0 0;
  color: white;
  border-color: transparent;
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.top-nav-ul {
  display: contents !important;
}
.top-nav-li {
  margin: 0 !important;
  font-weight: 500 !important;
}
.flex {
  display: flex;
}
.width-100 {
  width: 100%;
}
.width-50 {
  width: 50%;
}
.text-dark {
  color: black;
}
a[href="https://cbs.tw/disaster"]
{
  margin-right: 0px;
  white-space: nowrap;
}
marquee {
  padding: 5px;
}
</style>
